import React, {useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import MapAddressChooserField from "./MapAddressChooserField";
import Grid from "@mui/material/Grid2";
import AddressChooserOnMap from "./AddressChooserOnMap";
import Button from "@mui/material/Button";
import StaticMap from "./StaticMap";
import RayaField from "../../elements/fields/RayaField";
import validator from "validator";
import axios from "axios";
import {defaultVariables} from "../../../../config";
import LoadingButton from "../../elements/LoadingButton";
import {useSnackbar} from "notistack";
import {ArrowLeft, Home, BriefcaseBusiness,Heart } from "lucide-react";
import AppCardLoaderFields from "../../loaders/AppCardLoaderFields";
import MobileField from "../../elements/fields/MobileField";
import SubTitle from "../../elements/SubTitle";

const AddressHolder = (props) => {
    const { t } = useTranslation();
    const [loading, setLoading] = useState(true);
    const [location, setLocation] = useState({});
    const [level, setLevel] = useState(1);
    const [errors, setErrors] = useState({});
    const [hadMobile, setHadMobile] = useState(false);
    const [submitLoading, setSubmitLoading] = useState(false);
    const [customLabel, setCustomLabel] = useState(false);
    const { enqueueSnackbar } = useSnackbar();

    const initFields = {
        manual_address: '',
        building_name: '',
        flat: '',
        floor: '',
        icon: '',
        label: '',
        note: '',
        code: '',
        mobile: '',
    };
    const [fields, setFields] = useState(initFields);
    const loginToken = localStorage.getItem('ACT');
    const setMobile = (country,mobile) => {
        if(!!country?.phonecode && !!mobile){
            handleField('code',country.phonecode);
            handleField('mobile',mobile);
        }
    }
    const config = {
        headers: {
            Accept: 'application/json',
            Authorization: `Bearer ${loginToken}`
        }
    }
    const loadData = async () =>{
        await setLoading(true);
        const data = new FormData();
        if(!!props.shop_id){
            data.append('shop_id', props.shop_id);
        }
        if(!!props.courier_id){
            data.append('courier_id', props.courier_id);
        }
        if(!!props.address_id){
            data.append('address_id', props.address_id);
        }
        await axios.post(`${defaultVariables.url}/address/get`,data,config)
            .then(response => {
                if(!!response.data.lat){
                    setFields({
                        manual_address: response.data.manual_address,
                        building_name: response.data.building_name,
                        flat: response.data.flat,
                        floor: response.data.floor,
                        icon: response.data.icon,
                        label: response.data.label,
                        code: response.data.code,
                        mobile: response.data.mobile,
                        note: response.data.note,
                    });
                    setLocation({
                        address : response.data.address,
                        province: response.data.province,
                        country: response.data.country,
                        coordinates : {lat: response.data.lat, lng:response.data.lng},
                    })
                    if(!!response.data.mobile && !!response.data.code){
                        setHadMobile(true);
                    }
                    setLevel(2);
                    if(!!response.data.icon && !!response.data.label){
                        if(response.data.icon === "map-pin"){
                            setCustomLabel(true)
                        }
                    }
                }

                setLoading(false);
            })
            .catch(error => {
                console.error("Error fetching match data:", error);
                setLoading(false); // Set loading to false even if there is an error
            });
    }
    useEffect(() => {
        if(!!props.address_id || !!props.shop_id || !!props.courier_id){
            loadData();
        }else{
            setLoading(false);
        }

    }, [props.address_id,props.shop_id,props.courier_id]);

    useEffect(() => {
        if(props.new_location?.address){
            setLocation(props.new_location)
            handleField('manual_address',props.new_location.address)
            setLevel(2)
        }

    }, [props.new_location]);
    const handleLabelInput = (label) => {
        if(label === "custom"){
            handleField("label",t("address"))
            handleField("icon","")
            setCustomLabel(true)
        }else{
            handleField("label",t(label))
            handleField("icon",label)
            setCustomLabel(false)

        }

    }
    const handleChange = (e) => {
        let { name, value } = e.target;
        setFields((prevFields) => ({ ...prevFields, [name]: value }));
        setErrors((prevErrors) => ({ ...prevErrors, [name]: '' }));
    };

    const handleField = (input,val) => {
        setFields((prevFields) => ({ ...prevFields, [input] : val }));
        setErrors((prevErrors) => ({ ...prevErrors, [input]: '' }));
    };

    const setNextLevel = () => {
        if(!!location.address){
            if(location.country !== "Türkiye"){
                enqueueSnackbar(t('onlyTurkiye'), { variant: 'warning' });

            }else{
                handleField('manual_address',location.address)
                setLevel(2)
            }

        }
    }
    const setPrevLevel = () => {
        setLevel(1)
    }
    const handleValidation = async (callback) => {
        let formIsValid = true;
        let newErrors = {};
        if(!props.vendor){
            if(!!fields.mobile){
                if (!validator.isNumeric(fields.mobile) || fields.mobile.length < 9) {
                    formIsValid = false;
                    newErrors.mobile = t("wrongMobile");
                }
            }
            if(!fields.building_name){
                formIsValid = false;
                newErrors.building_name = t("emptyField");
            }
            if(!fields.floor){
                formIsValid = false;
                newErrors.floor = t("emptyField");
            }
            if(!fields.manual_address){
                formIsValid = false;
                newErrors.manual_address = t("emptyField");
            }

        }

        setErrors(newErrors);
        if (!formIsValid) setSubmitLoading(false);
        callback(formIsValid);
    };

    const handleRequest = async () => {

        const data = new FormData();
        data.append('address', location.address);
        data.append('province', location.province);
        data.append('country', location.country);
        data.append('lat', location?.coordinates?.lat);
        data.append('lng', location?.coordinates?.lng);
        data.append('manual_address', fields.manual_address);
        data.append('building_name', fields.building_name);
        data.append('flat', fields.flat);
        data.append('floor', fields.floor);
        if(!props.vendor){
            data.append('label', fields.label);
            data.append('icon', !!fields.icon ? fields.icon : 'map-pin');
            data.append('note', fields.note);
            if(!!fields.code && !!fields.mobile){
                data.append('code', fields.code);
                data.append('mobile', fields.code+fields.mobile);
            }
        }
        if(!!props.shop_id){
            data.append('shop_id', props.shop_id);
        }
        if(!!props.courier_id){
            data.append('courier_id', props.courier_id);
        }
        if(!!props.address_id){
            data.append('address_id', props.address_id);
        }
        const loginToken = localStorage.getItem('ACT');
        const config = {
            headers: {
                Accept: 'application/json',
                Authorization: `Bearer ${loginToken}`
            }
        };

        try {
            const response = await axios.post(`${defaultVariables.url}/address/make`, data, config);
            setSubmitLoading(false);
            props.handleAddressDone()

        } catch (error) {
            console.error(error);
            if(error.response?.status === 422){
                enqueueSnackbar(t('cantEditAddressInUse'), { variant: 'error' });
            }else{
                enqueueSnackbar(t('detailsSetFailed'), { variant: 'error' });
            }
            setSubmitLoading(false);

        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        setSubmitLoading(true);
        handleValidation((valid) => {
            if (valid) handleRequest();
        });
    };
    if (loading) {
        return <AppCardLoaderFields />;
    }
    return (
            <Grid container spacing={2}>
                {
                    level === 1 ?
                        <>
                            <Grid item size={12}>
                                <MapAddressChooserField clName="real-chooser" setLocation={(res) => setLocation(res)} location={location}/>
                            </Grid>
                            <Grid item size={12}>
                                <AddressChooserOnMap setLocation={(res) => setLocation(res)} location={location}/>
                            </Grid>
                            <Grid item size={12} style={{textAlign:"center"}}>
                                <Button
                                    variant="contained"
                                    onClick={() => setNextLevel()}
                                    disabled={!location.coordinates}
                                >
                                    {t('submitInfo')}
                                </Button>
                            </Grid>
                        </>
                        :
                        <>
                            <Grid item size={12}>
                                <StaticMap
                                    height={200}
                                    coordinates={location.coordinates}
                                    radiusKm={props.radius}
                                />
                            </Grid>
                            <Grid item size={12}>
                                <Button
                                    startIcon={<ArrowLeft/>}
                                    onClick={() => setPrevLevel()}
                                >
                                    {t('back')}
                                </Button>
                            </Grid>
                            <Grid item size={{xs: 12}}>
                                <RayaField
                                    variant="outlined"
                                    multiline
                                    required
                                    fullWidth
                                    name="manual_address"
                                    label={t('address')}
                                    type="text"
                                    rows="4"
                                    value={fields.manual_address}
                                    onChange={handleChange}
                                    error={!!errors['manual_address']}
                                    helperText={errors['manual_address']}
                                />
                            </Grid>
                            {
                                !props.courier_id &&
                                <>
                                    <Grid item size={{xs: 12}}>
                                        <RayaField
                                            variant="outlined"
                                            required
                                            fullWidth
                                            label={t('building_name')}
                                            name="building_name"
                                            value={fields.building_name}
                                            onChange={handleChange}
                                            error={!!errors.building_name}
                                            helperText={errors.building_name}
                                        />
                                    </Grid>
                                    <Grid item size={{xs: 6}}>
                                        <RayaField
                                            variant="outlined"
                                            required
                                            fullWidth
                                            optional
                                            label={t('flat')}
                                            name="flat"
                                            value={fields.flat}
                                            onChange={handleChange}
                                            error={!!errors.flat}
                                            helperText={errors.flat}
                                        />
                                    </Grid>
                                    <Grid item size={{xs: 6}}>
                                        <RayaField
                                            variant="outlined"
                                            required
                                            fullWidth
                                            label={t('floor')}
                                            name="floor"
                                            value={fields.floor}
                                            onChange={handleChange}
                                            error={!!errors.floor}
                                            helperText={errors.floor}
                                        />
                                    </Grid>
                                </>
                            }

                            {
                                !props.vendor &&
                                <>
                                    <Grid item size={{xs: 12, md:6}}>
                                        {
                                            !!hadMobile ?
                                                <RayaField
                                                    fullWidth
                                                    label={t("mobile")}
                                                    name="mobile"
                                                    variant="outlined"
                                                    value={fields.mobile}
                                                    onChange={handleChange}
                                                    error={!!errors.mobile}
                                                    helperText={errors.mobile}

                                                />
                                                :
                                                <MobileField
                                                    autoFocus={false}
                                                    setMobile={setMobile}
                                                    error={errors['mobile']}
                                                />
                                        }

                                    </Grid>
                                    <Grid item size={{xs: 12}}>
                                        <SubTitle align="left">{t('addressLabel')}</SubTitle>
                                        <div className="address-labels">
                                            <Button
                                                variant={fields.label === t('home') ? "contained" : "outlined"}
                                                onClick={() => handleLabelInput('home')}
                                                startIcon={<Home/>}
                                                color={fields.label === t('home') ? "secondary" : "default"}
                                            >
                                                {t('home')}
                                            </Button>
                                            <Button
                                                variant={fields.label === t('work') ? "contained" : "outlined"}
                                                onClick={() => handleLabelInput('work')}
                                                startIcon={<BriefcaseBusiness/>}
                                                color={fields.label === t('work') ? "secondary" : "default"}

                                            >
                                                {t('work')}
                                            </Button>
                                            <Button
                                                variant={fields.label === t('partner') ? "contained" : "outlined"}
                                                onClick={() => handleLabelInput('partner')}
                                                startIcon={<Heart/>}
                                                color={fields.label === t('partner') ? "secondary" : "default"}

                                            >
                                                {t('partner')}
                                            </Button>
                                            <Button
                                                variant={(fields.label !== t('partner') && fields.label !== t('work') && fields.label !== t('home') && !!fields.label) ? "contained" : "outlined"}
                                                color={(fields.label !== t('partner') && fields.label !== t('work') && fields.label !== t('home') && !!fields.label) ? "secondary" : "default"}
                                                onClick={() => handleLabelInput('custom')}
                                            >
                                                {t('customLabel')}
                                            </Button>
                                        </div>
                                        {
                                            !!customLabel &&
                                            <RayaField
                                                variant="outlined"
                                                required
                                                fullWidth
                                                label={t('addressLabel')}
                                                placeholder={t('addressLabelPlaceholder')}
                                                name="label"
                                                value={fields.label}
                                                onChange={handleChange}
                                                error={!!errors.label}
                                                helperText={errors.label}
                                            />
                                        }

                                    </Grid>
                                    <Grid item size={{xs: 12}}>
                                        <RayaField
                                            variant="outlined"
                                            multiline
                                            fullWidth
                                            name="note"
                                            label={t('addressNote')}
                                            placeholder={t('addressNotePlaceholder')}
                                            type="text"
                                            rows="4"
                                            value={fields.note}
                                            onChange={handleChange}
                                            error={!!errors['note']}
                                            helperText={errors['note']}
                                        />
                                    </Grid>
                                </>
                            }
                            <Grid item size={12}>
                                <LoadingButton
                                    variant="contained"
                                    color="secondary"
                                    onClick={handleSubmit}
                                    loading={submitLoading}
                                >
                                    {t('setDetails')}
                                </LoadingButton>
                            </Grid>
                        </>
                }


            </Grid>
    );
};

export default AddressHolder;
